<template>
	<div class="hello">
		<div class="header">
			<van-nav-bar title="" left-text="返回" @click-left="backJump" left-arrow>
			  <template #right>
				  <van-icon name="ellipsis" />
			  </template>
			</van-nav-bar>
			<img src="../assets/topback.png" style="width: 190px;height: 146px;float: right;" alt="">
			<div>
				<h2><span>缴</span>费信息确认</h2>
			</div>
		</div>
		<div class="center" style="position: relative;">
			<div class="content">
				<div class="bt water">
					<img src="../assets/dian.png" >
					<span>电费</span>
				</div>
				<div class="heiall">
					<p>识别编码</p>
					<van-field v-model="content.houseHoldNumber" label="" style="border-bottom: 1px solid #dee1e5;" />
				</div>
				<div class="heiall">
					<p>地址</p>
					<van-field v-model="content.devAddress" label="" style="border-bottom: 1px solid #dee1e5;" />
				</div>
				<van-button loading type="primary" loading-type="spinner" loading-text="正在加载" :style="logo" />
			</div>
		</div>
		<div class="footer" @click="waterInsert">
			<van-button type="primary" style="background-color: #2D86F6;font-size: 17px;letter-spacing: 1px;height: 50px;" block>确认添加缴费</van-button>
		</div>
	</div>
</template>

<script>
  import {paySure} from "../common/api/payReally";
  import jump from "../common/jump";
	export default {
	  data() {
		  return{
        content:[],
			  logo:{
			  	display:'none'
			  }
		  }
		  
	  },
	  mounted(){
	    this.content = this.$route.query
	  },
	  methods:{
	    //确认添加缴费
		  waterInsert:function(){
			  console.log(this.payType)
        console.log(this.content)
			  let param = JSON.stringify(this.content)
        console.log("oaras",param)
        paySure(param).then((response)=> {
          if(response.code == 200){
            this.$router.push({path: "/index"})
          }
          else{
            this.$toast.fail(response.msg)
          }
			  })
			  .catch(function (error) {
			    console.log(error)
			  });
		  },
      //加载动画
		  sure:function(){
			  this.logo.display = 'block'
		  },
      //返回上一页面
      backJump(){
        this.$destroy()
        jump.$emit('back')
        this.$router.go(-1)
      },
	  }
	};
</script>

<style scoped>
	.clear{
		clear: both;
	}
	.header{
		width: 100%;
		height: 192px;
		background-color: #295ad0;
	}

	.header h2{
		letter-spacing:2px;
		color: rgb(255, 255, 255);
		line-height: 70px;
		position: relative;
		margin-left:20px
	}
	.header h2 span{
		border-bottom: 3px solid #fff;
	}
	.center{
		width:90%;
		height:307px;
		margin: 0 auto;
		border-radius: 10px;
		margin-top: -15px;
		border:1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 15px -5px;
		background-color: #fff;
	}
	.content{
		width:80%;
		margin: 0 auto;
		font-weight: "黑体";
		
	}
	.content .heiall{
		height:80px;
		margin-top: 5px;
		line-height: 50px;
	}
	.heiall p{
		color: #8e8e8e;
	}
	.bt{
		margin-top:20px
	}
	.bt img{
		width: 38px;
		height:38px;
		float: left;
	}
	.bt span{
		line-height: 42px;
		margin-left: 10px;
		font-size: 20px;
	}
	.footer{
		width: 90%;
		margin:40px auto;
	}
</style>
